import { render, staticRenderFns } from "./InternalDossiersFormView.vue?vue&type=template&id=2e1bcb12"
import script from "./InternalDossiersFormView.vue?vue&type=script&lang=js"
export * from "./InternalDossiersFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports